import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { SortingCenterBoldIcon } from "../../../utils/icones";
import { useActionSheet } from "../../Generic/AppActionSheet/useActionSheet";
import useMainVisitSortingPreference, {
  MainVisitSortingPreference,
  mainVisitSortingPreferenceOptions,
} from "../hooks/useMainVisitSortingPreference";
import NavbarActionButton from "./NavbarActionButton";

export default function SortPreferenceButton() {
  const { createActionSheet } = useActionSheet();
  const [, setSorting] = useMainVisitSortingPreference();

  return (
    <NavbarActionButton
      icon={<SortingCenterBoldIcon fontSize={20} color="white" />}
      onClick={() => {
        createActionSheet({
          options: mainVisitSortingPreferenceOptions.map((sorting) => ({
            value: sorting,
            text: getSortingTranslation(sorting),
          })),
          onChange: setSorting,
        });
      }}
    />
  );
}

function getSortingTranslation(sortingValue: MainVisitSortingPreference) {
  switch (sortingValue) {
    case "PostedDate":
      return translate(STRINGS.POSTED_DATE);
    case "StartDate":
      return translate(STRINGS.START_DATE);
    case "Distance":
      return translate(STRINGS.DISTANCE);
    case "Price":
      return translate(STRINGS.PRICE);
    case "Priority":
      return translate(STRINGS.RECOMMENDED);
  }
}
